import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import ProcessCheckBar from 'components/Hospital/ProcessCheckBar';
import { IDDiagnosisNull } from 'models/DCK/basicInterface';
import { getDiagnosisStatus } from 'pages/DCK/utils';
import React from 'react';
import styled from 'styled-components';
import { BackgroundColor, TextColor } from 'styles/Global/colorSemantic';
import { Body4Medium, Body5Medium, Body5Regular, Title2Bold } from 'styles/Global/typography';
import { calculateAge } from 'utils/calculateAge';

interface ProfileCardViewProps {
    data: IDDiagnosisNull;
    info: { [key: string]: any };
}

export const ProfileCardView = ({ data, info }: ProfileCardViewProps) => {
    const { birthDate, ageString } = calculateAge(data.patientIdentityNumber!);

    return (
        <Layout>
            <ProfileArea>
                <NameWrapper>
                    {data.patientName}
                    {data.patientGender === 'male' ? <GenderMan $width='20px' $height='20px' /> : <GenderWoman $height='20px' $width='20px' />}
                </NameWrapper>
                <FlexWrapper>
                    <BirthDateWrapper>{birthDate}</BirthDateWrapper>
                    <Age>({ageString})</Age>
                </FlexWrapper>
            </ProfileArea>
            <InfoContianer>
                {Object.entries(info).map(([label, value]) => (
                    <InfoWrapper key={label}>
                        <Label>{label}</Label>
                        <Info>{value || '-'}</Info>
                    </InfoWrapper>
                ))}
                {(getDiagnosisStatus(data) === 'counselComplete' || getDiagnosisStatus(data) === 'noshow') && (
                    <InfoWrapper>
                        <Label $type='processbar'>진행 상태</Label>
                        <Info>
                            <ProcessCheckBar diagnosisInfo={data} $width='136px' $height='32px' hover='none' $type='mindupAdminMobile' />
                        </Info>
                    </InfoWrapper>
                )}
            </InfoContianer>
        </Layout>
    );
};

const Layout = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;

const ProfileArea = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    width: 100%;
`;

const NameWrapper = styled(Title2Bold)`
    display: flex;
    align-items: center;
    width: 100%;
`;

const BirthDateWrapper = styled(Body5Medium)`
    display: flex;
    align-items: center;
    gap: 4px;
`;

const Age = styled(Body5Regular)`
    color: ${TextColor.color_text_weak};
`;

const FlexWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

const InfoContianer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 18px 20px;
    width: 100%;
    gap: 8px;
    align-self: stretch;
    background-color: ${BackgroundColor.color_background_light};
    border-radius: 8px;
`;
const InfoWrapper = styled.div`
    display: flex;
    gap: 16px;
    // align-items: center;
`;

const Label = styled(Body5Regular)<{ $type?: string }>`
    display: flex;
    align-items: center;
    width: 60px;
    height: ${({ $type }) => !$type && '22px'};
`;

const Info = styled(Body4Medium)`
    display: flex;
    align-items: center;
    width: calc(100% - 60px - 16px);
    gap: 8px;
`;
